var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPitch = function SvgPitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M15 15h7M2 15h5.426M2 22h20M2 8h20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.326 2a.75.75 0 1 0-1.5 0zm-.559 10.647a.75.75 0 1 0-.383-1.45zm-1.68 4.664-.192-.726zm-4.172-3.893-.192-.725zm-2.24 1.934v.857h1.5v-.857zm3.453 3.516 3.15-.832-.383-1.45-3.15.832zm5.198-3.491V2h-1.5v13.377zm-.942-4.18-5.661 1.496.383 1.45 5.661-1.496zm-1.106 6.839a2.75 2.75 0 0 0 2.047-2.659h-1.5a1.25 1.25 0 0 1-.93 1.208zm-6.602-1.827a2.75 2.75 0 0 0 3.452 2.66l-.383-1.451a1.25 1.25 0 0 1-1.57-1.209zm1.5-.857c0-.568.382-1.064.93-1.209l-.383-1.45a2.75 2.75 0 0 0-2.047 2.659z"
  })));
};
export default SvgPitch;